import React, { useState } from 'react';
import './index.less';
import { v4 as uuid } from 'uuid';
import { IParsePPTToClientTemplateResult } from '../ppt-parse/upload-model/type';
import Processing from './components/processing';
import Title from './components/title';
import Upload from './components/upload';
import { IParsePsdToClientTemplateResult, PsdParseWarnType } from './core/types';
import { InfoProps, IPsdParseModalProps } from './type';
import { MAX_FILE_SIZE } from './utils';

export const PsdParseModalContainer: React.FC<IPsdParseModalProps> = ({
    title = '文件解析',
    helpDocUrl,
    finishCallback,
    closeCallback,
    className,
    style,
    noReplaceFontFamily,
    noParseBgLayer,
    parseNoLimit,
    parseLayerCallback,
    uploadFileToOBS,
    showCloseButton = false,
}) => {
    const [psdFile, setPsdFile] = useState<File | null>(null);
    const [infos, setInfos] = useState<InfoProps[]>([]);

    const uploadCallback = (file: File) => {
        if (file.size > MAX_FILE_SIZE) {
            setInfos([
                {
                    text: '文件超过600MB, 请重新上传',
                    infoType: PsdParseWarnType.Error,
                    id: uuid(),
                },
            ]);
            return;
        }

        if (!file.name.endsWith('.psd') && !file.name.endsWith('.pptx')) {
            setInfos([
                {
                    text: '非psd或ppt文件, 请重新上传',
                    infoType: PsdParseWarnType.Error,
                    id: uuid(),
                },
            ]);
            return;
        }

        setInfos([
            {
                text: '开始解析',
                infoType: PsdParseWarnType.Info,
                id: uuid(),
            },
        ]);

        setPsdFile(file);
    };

    const parseDoneCallback = (data: IParsePsdToClientTemplateResult | IParsePPTToClientTemplateResult | null) => {
        finishCallback(data);
    };

    const reUploadClick = () => {
        setPsdFile(null);
    };

    return (
        <div className={`c-psd-parse-warp ${className}`} style={style}>
            <div className="c-psd-parse-mask"></div>
            <div className="c-psd-parse-cutout">
                <Title
                    title={title}
                    helpDocUrl={helpDocUrl}
                    closeCallback={closeCallback}
                    showCloseButton={showCloseButton}
                />
                {!psdFile ? <Upload uploadCallback={uploadCallback} /> : null}
                {psdFile ? (
                    <Processing
                        file={psdFile}
                        reUploadClick={reUploadClick}
                        setInfos={setInfos}
                        infos={infos}
                        parseDoneCallback={parseDoneCallback}
                        noReplaceFontFamily={noReplaceFontFamily}
                        noParseBgLayer={noParseBgLayer}
                        parseNoLimit={parseNoLimit}
                        parseLayerCallback={parseLayerCallback}
                        uploadFileToOBS={uploadFileToOBS}
                    />
                ) : null}
            </div>
        </div>
    );
};
